<section class="w-full h-full p-4 flex content-between flex-wrap">
    <!-- user info -->
    <div class="w-full flex justify-center flex-wrap">
        <div class="w-full flex flex-wrap items-center justify-center mb-4">
            <div class="flex items-center justify-center w-20 h-20 bg-red-50 rounded-full">
                <span class="icon restricted-regular text-2xl text-red-700 dark:text-red-600"></span>
            </div>

        </div>
        <span class="text-sm md:text-base font-medium text-center text-gray-900">{{user?.objectOwner?.fullName}} شما
            را محدود کرده است</span>
    </div>
    <!-- access -->
    <!-- @if(restrictType === 'mention'){
    <div class="w-full flex flex-wrap">
        <div class="w-full flex items-center text-gray-800">
            <span
                class="icon subtract-circle-regular text-xl ml-4 bg-gray-100 dark:bg-gray-800 p-2 rounded-full"></span>
            <span class="text-sm">
                این کاربر شما را محدود کرده است و امکان منشن یا تعامل با او برای شما وجود ندارد!
            </span>
        </div>

    </div>
    }@else{ -->
    <div class="w-full flex flex-wrap py-4">
        <div class="w-full py-2 flex items-center text-gray-800">
            <span class="icon content-view-regular text-xl ml-4 bg-gray-100 dark:bg-gray-800 p-2 rounded-full"></span>
            <span class="text-sm">
                فقط <strong class="text-sm">می‌توانید </strong>محتوا را ببینید.
            </span>
        </div>
        <div class="w-full py-2 flex items-center text-gray-800">
            <span
                class="icon subtract-circle-regular text-xl ml-4 bg-gray-100 dark:bg-gray-800 p-2 rounded-full"></span>
            <span class="text-sm">
                <strong class="text-sm">نمی‌توانید</strong> محتوا را بپسندید یا نظر بگذارید.
            </span>
        </div>

    </div>
    <!-- } -->

    <button class="w-full h-8 !text-xs md:!text-sm !px-2 btn-green-flat !outline-none !border-none" (click)="close()">
        متوجه شدم
    </button>
</section>